module.exports = __webpack_public_path__ + "media/assets/images/flags/th-a0845df1aeb7d2a95ac2e0b834495030.svg";